$ = require('jquery')
l = require('lib/localize')

$.fn.format = (key, data) ->
  @text l(key, data, { raw: true })
  @

$.fn.formatHtml = (key, data) ->
  @html l(key, data)
  @



// WEBPACK FOOTER //
// ./app/scripts/lib/jquery-localize.coffee